import React from 'react';
import cx from 'classnames';
import config from '@plone/volto/registry';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { BG_CONTAINER_COLORS } from '../../colors';
import './BGContainer.scss';


const BGContainerView = (props) => {
  const { data = {}, properties = {}, className, style } = props;
  const bgVar = style?.['--backgroundColor--background-color'];

  const selectedColor = BG_CONTAINER_COLORS.find(
    (item) => item.style['--background-color'] === bgVar,
  );

  const content = {
    ...properties,
    blocks: data.blocks || {},
    blocks_layout: data.blocks_layout || { items: [] },
  };

  return (
    <div
      className={cx(
        'block',
        className,
        'bg-content-wrapper',
        data.fullWidth && 'bg-content-wrapper-fullwidth',
        selectedColor?.name && `bg-content-wrapper-${selectedColor.name}`
      )}
      style={style}
    >
      <div
        className={cx(
          className,
          data.fullWidth && 'ui',
          'container',
          'bg-content-wrapper-inner'
        )}
      >
        <RenderBlocks
          content={content}
          blocksConfig={config.blocks.blocksConfig}
        />
      </div>
    </div>
  );
};

export default BGContainerView;
